import React from 'react';
import PropTypes from 'prop-types';
import {
  propTypeStorePaymentMethod,
  propTypeOrder,
  propTypesCmsContent,
  propTypeCustomerSavedCards
} from './shared.propTypes';

import CookieDoughWidget from '../CookieDoughWidget/CookieDoughWidget';
import { isDoughProOrder } from '../../shared/utilities/orders';
import styles from './shared.module.css';
import { getPaymentMethodGroups } from './shared';
import PaymentMethodGroup from './PaymentMethodGroup/PaymentMethodGroup';
import { groupTitles, orderTypeIds } from '../../shared/constants/order';
import Tip from '../../pages/ReviewOrder/Tip/Tip';
import { getCheckoutPartProps } from '../../pages/ReviewOrder/reviewOrderBrandRefreshClasses';

const PaymentWidget = props => {
  const {
    storePaymentMethods,
    order,
    orderTypeId,
    paymentMethodsCustomerSaved,
    updatePaymentCredentials,
    isDoughProMember,
    isLoggedIn,
    cmsContent,
    updateEmbeddedPaymentMethod,
    orderTotal,
    completeOrderError,
  } = props;

  const isSavePaymentMethodCheckedAndDisabled = orderTypeId && isDoughProOrder(orderTypeId);

  const paymentMethodGroups = getPaymentMethodGroups(
    storePaymentMethods,
    isLoggedIn ? paymentMethodsCustomerSaved : null
  );

  const customerHasCookieDough = order.customer?.loyalty && !isDoughProOrder(order.orderTypeId);
  const defaultPaymentCredential = order?.defaultPaymentCredential;

  const giftCardPayment = paymentMethodGroups.filter(
    payment => payment.groupTitle === groupTitles.giftCard
  );
  const otherPayments = paymentMethodGroups.filter(
    payment => payment.groupTitle !== groupTitles.giftCard
  );

  return (
    <div
      className={`${styles.paymentWidget} `}
      data-part={getCheckoutPartProps('payment-widget')}
    >
      {giftCardPayment.map(pmcg => (
        <div
          key={pmcg.groupTitle}
          className={`
          ${styles.paymentMethodGroupContainer}
          border-b-2 border-lightDry dark:border-darkDry text-dark dark:text-white bg-white dark:bg-dark shadow-md `}
          data-part={getCheckoutPartProps('payment-method-group')}
        >
          <PaymentMethodGroup
            paymentMethodComponentGroup={pmcg}
            isSavePaymentMethodCheckedAndDisabled={
              isSavePaymentMethodCheckedAndDisabled
            }
            isSavePaymentMethodAllowed={isLoggedIn}
            paymentMethodsCustomerSaved={paymentMethodsCustomerSaved}
            updatePaymentCredentials={updatePaymentCredentials}
            isDoughProMember={isDoughProMember}
            isLoggedIn={isLoggedIn}
            cmsContent={cmsContent}
            updateEmbeddedPaymentMethod={updateEmbeddedPaymentMethod}
            defaultPaymentCredential={defaultPaymentCredential}
            completeOrderError={completeOrderError}
          />
        </div>
      ))}

      {order.orderTypeId === orderTypeIds.delivery && (
        <Tip key={`${order.tip}`} />
      )}

      {otherPayments.map(pmcg => (
        <div
          key={pmcg.groupTitle}
          className={`
          ${styles.paymentMethodGroupContainer}
          border-b-2 border-lightDry dark:border-darkDry text-dark dark:text-white bg-white dark:bg-dark shadow-md `}
          data-part={getCheckoutPartProps('payment-method-group')}
        >
          <PaymentMethodGroup
            paymentMethodComponentGroup={pmcg}
            isSavePaymentMethodCheckedAndDisabled={
              isSavePaymentMethodCheckedAndDisabled
            }
            isSavePaymentMethodAllowed={isLoggedIn}
            paymentMethodsCustomerSaved={paymentMethodsCustomerSaved}
            updatePaymentCredentials={updatePaymentCredentials}
            isDoughProMember={isDoughProMember}
            isLoggedIn={isLoggedIn}
            cmsContent={cmsContent}
            updateEmbeddedPaymentMethod={updateEmbeddedPaymentMethod}
            orderTotal={orderTotal}
            defaultPaymentCredential={defaultPaymentCredential}
            completeOrderError={completeOrderError}
          />
        </div>
      ))}
      {customerHasCookieDough && <CookieDoughWidget order={order} />}
    </div>
  );
};

PaymentWidget.propTypes = {
  storePaymentMethods: PropTypes.arrayOf(propTypeStorePaymentMethod).isRequired,
  order: propTypeOrder.isRequired,
  orderTypeId: PropTypes.number.isRequired,
  paymentMethodsCustomerSaved: propTypeCustomerSavedCards.isRequired,
  updatePaymentCredentials: PropTypes.func.isRequired,
  isDoughProMember: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  cmsContent: propTypesCmsContent,
  updateEmbeddedPaymentMethod: PropTypes.func.isRequired,
  orderTotal: PropTypes.number.isRequired,
  completeOrderError: PropTypes.string,
};

PaymentWidget.defaultProps = {
  isDoughProMember: false,
  isLoggedIn: false,
  cmsContent: [],
  completeOrderError: '',
};

export default PaymentWidget;
